var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-2 -2 64 64",
    id: "Diagram-Curve-Rise-Dash--Streamline-Ultimate",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Diagram Curve Rise Dash Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m57.5625 30.08325 -7.35 -7.35 -7.35 7.35",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.43744 28.245749999999997 0.0195 -5.5125c0.0225 -0.69925 0.12775999999999998 -1.39325 0.31376000000000004 -2.0677499999999998",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.460025 14.69975c2.149 -1.017 4.5385 -1.4165 6.90175 -1.154",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.883249999999997 15.01825c2.0164999999999997 1.283 3.479 3.27525 4.09875 5.5835",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.325 28.37325v7.09275",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.3145 42.82575c1.4602499999999998 1.8904999999999998 3.5625 3.1805 5.90925 3.626",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M42.004999999999995 46.53275c2.3765 -0.29425 4.5465 -1.49825 6.054 -3.359",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M50.212500000000006 35.8555V22.733249999999998",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingRed);
export default __webpack_public_path__ + "static/media/TrackingRed.f8fa31ee15e3d5a934ff546fe370efbf.svg";
export { ForwardRef as ReactComponent };